import { createContext, useContext } from "react";
export const createDefaultTemplateDebugContext = () => ({
    enabled: false,
    isFieldVisible: (f, actualVisibilty) => actualVisibilty,
    getSectionProps: (section, preExistingProps) => preExistingProps || {},
    getFieldProps: (field, preExistingProps) => preExistingProps || {},
    getTableColumnProps: (tableColumn, preExistingProps) => preExistingProps || {}
});
export const templateDebugContext = createContext(createDefaultTemplateDebugContext());
templateDebugContext.displayName = "TemplateDebugContext";
export const useTemplateDebugManager = () => {
    const state = useContext(templateDebugContext);
    return state;
};
export const useGetDebugSectionProps = () => useTemplateDebugManager().getSectionProps;
export const useGetDebugFieldProps = () => useTemplateDebugManager().getFieldProps;
export const useGetDebugTableColumnProps = () => useTemplateDebugManager().getTableColumnProps;
export const TemplateDebugProvider = templateDebugContext.Provider;
export const createDefaultCalcRuleContext = () => ({
    enabled: false,
    setCalculationResponse: () => { }
});
export const calcRuleDebugContext = createContext(createDefaultCalcRuleContext());
calcRuleDebugContext.displayName = "CalcRuleDebugContext";
export const useCalcRuleDebugManager = () => {
    const state = useContext(calcRuleDebugContext);
    return state;
};
export const CalcRuleDebugProvider = calcRuleDebugContext.Provider;
//# sourceMappingURL=debugContext.js.map